export default __webpack_public_path__ + "static/media/OchurchillClosed.75f9eb97.jpg";